import { clsx } from "clsx";
import { WEEKDAY_OPTIONS, WEEKDAYS_MON_FRI } from "@/types/availability";

interface Props {
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

/**
 * "Repeat on" weekday toggles for a WEEKLY recurrence (Google-Calendar style). Pick
 * specific days (e.g. Wed/Thu) or use the Mon–Fri preset to skip weekends. Empty means
 * the recurrence falls on the start day's weekday.
 */
export function WeekdayPicker({ value, onChange, disabled }: Props) {
  const toggle = (code: string) =>
    onChange(value.includes(code) ? value.filter((c) => c !== code) : [...value, code]);

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {WEEKDAY_OPTIONS.map((d) => {
        const active = value.includes(d.code);
        return (
          <button
            key={d.code}
            type="button"
            disabled={disabled}
            onClick={() => toggle(d.code)}
            aria-pressed={active}
            className={clsx(
              "px-2 py-1 rounded-md text-xs font-medium border transition-colors",
              active
                ? "bg-bridge-accent text-white border-bridge-accent"
                : "bg-bridge-surface text-bridge-muted border-bridge-border/60 hover:text-bridge-fg",
              disabled && "opacity-50 cursor-not-allowed",
            )}
          >
            {d.label}
          </button>
        );
      })}
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange([...WEEKDAYS_MON_FRI])}
        className="ml-1 text-[11px] text-bridge-accent hover:underline disabled:opacity-50"
      >
        Mon–Fri
      </button>
    </div>
  );
}